import { render, staticRenderFns } from "./JurisdictionsList.vue?vue&type=template&id=ab3febc8&scoped=true&"
import script from "./JurisdictionsList.vue?vue&type=script&lang=js&"
export * from "./JurisdictionsList.vue?vue&type=script&lang=js&"
import style0 from "./JurisdictionsList.vue?vue&type=style&index=0&id=ab3febc8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3febc8",
  null
  
)

export default component.exports